'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dFeatures$0024 from "./presto.types$-Features$.js";
var $p;
/** @constructor */
function $c_Lpresto_ListTwoFactorAuth(name, url) {
  this.CX = null;
  this.CY = null;
  this.CX = name;
  this.CY = url;
}
export { $c_Lpresto_ListTwoFactorAuth as $c_Lpresto_ListTwoFactorAuth };
$p = $c_Lpresto_ListTwoFactorAuth.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_ListTwoFactorAuth;
/** @constructor */
function $h_Lpresto_ListTwoFactorAuth() {
}
export { $h_Lpresto_ListTwoFactorAuth as $h_Lpresto_ListTwoFactorAuth };
$h_Lpresto_ListTwoFactorAuth.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_ListTwoFactorAuth)) {
    var x = this.CX;
    var x$2 = x$0.CX;
    if (((x === null) ? (x$2 === null) : x.i(x$2))) {
      var x$3 = this.CY;
      var x$4 = x$0.CY;
      return ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "ListTwoFactorAuth";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.CX;
  }
  if ((n === 1)) {
    return this.CY;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.dw = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_presto$002etypes$0024$002dFeatures$0024.$m_Lpresto_types$Features$().Yq);
});
function $isArrayOf_Lpresto_ListTwoFactorAuth(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iG)));
}
export { $isArrayOf_Lpresto_ListTwoFactorAuth as $isArrayOf_Lpresto_ListTwoFactorAuth };
var $d_Lpresto_ListTwoFactorAuth = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_ListTwoFactorAuth, "presto.ListTwoFactorAuth", ({
  iG: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_ListTwoFactorAuth as $d_Lpresto_ListTwoFactorAuth };
//# sourceMappingURL=presto.-List-Two-Factor-Auth.js.map
